import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  ButtonRow,
  FormLayout,
  Heading,
  HorizontalRule,
  Panel,
  Paragraph,
  Section,
  withTrackPage,
} from '@piggybank/core';

import {
  Field,
  FieldFeedback,
  Form,
  FormFeedback,
  Hint,
  Label,
} from '@piggybank/form';

import CurrencyInput from '~/components/CurrencyInput';
import schema from './enterAmountSchema';
import { formatAmountByValue } from '~/genericFunctions';
import { getHeaderKey, setPageTitle, isButtonVisible } from './enterAmountFunctions';
import get from 'lodash/get';

import nls from './nls/EnterAmount';
import { createTranslator } from '~/lib/nls-helper';

import getEnvironment from '~/lib/environment';

import { withAppContext } from '~/AppContext';

const environment = getEnvironment();
const NLS = createTranslator(nls);
const minAmount = '200';

const EnterAmount = ({ data }) => {
  const heading = NLS`${getHeaderKey(data.displayData.globalData.offerId)}`;
  return (
    <FormLayout>
      <Section>
        <Heading level={1}>{heading}</Heading>
      </Section>
      <Form
        initialValues={{ 'requestedAmount': '' }}
        onSubmit={setPageTitle(heading)}
        validationSchema={schema(minAmount, get(data.displayData.loanOffer, 'loanOptions[0].principal.amount'))}
      >
        {() => (
        <>
          <FormFeedback textMap={{ title: NLS`Please correct the following:` }}/>
          <Section>
            <Panel marginBottom={6}>
              <Paragraph lead marginBottom={0}>
                <strong>
                  {`${NLS`You have available credit up to`} ${formatAmountByValue(get(data.displayData.loanOffer, 'loanOptions[0].principal.amount'))}`}
                </strong>
              </Paragraph>
              <Paragraph lead marginBottom={5}>
                {`${NLS`to payments of`} ${formatAmountByValue(get(data.displayData.loanOffer, 'loanOptions[0].payment.amount.amount'))}*`}
              </Paragraph>
              <Hint>{`*${NLS`The amount of your payments will change according to the amount of credit you captured`}`}</Hint>
            </Panel>
            <Field marginBottom={7} name="requestedAmount">
              <Label>{`${NLS`Capture the amount you want`}:`}</Label>
              <CurrencyInput
                decimalSeparator="."
                inputmode="decimal"
                maxLength={7}
                precision={2}
                symbol="$"
                thousandSeparator=","
                type="text"
              />
              <FieldFeedback />
            </Field>
            <HorizontalRule hiddenOnSmallViewport />
            <ButtonRow>
              <Button>{NLS`Continue`}</Button>
              {isButtonVisible(data.displayData.globalData.ismobile) &&
                <Button elementType="a" href={environment.bankingDashboardUrl} secondary target="_self">{NLS`Back`}</Button>
              }
            </ButtonRow>
          </Section>
        </>
        )}
      </Form>
    </FormLayout>
  );
};

EnterAmount.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      loanOffer: PropTypes.object,
      offerId: PropTypes.string,
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('enterAmount', 'component')
)(EnterAmount);
